import React from 'react';

interface OperationsIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const CrossIconHeader: React.FC<OperationsIconProps> = ({
  color = '#111928',
  ...props
}) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 9L17.625 1.375C17.9062 1.09375 17.9062 0.65625 17.625 0.375C17.3438 0.09375 16.9062 0.09375 16.625 0.375L9 8L1.375 0.375C1.09375 0.09375 0.65625 0.09375 0.375 0.375C0.09375 0.65625 0.09375 1.09375 0.375 1.375L8 9L0.375 16.625C0.09375 16.9062 0.09375 17.3438 0.375 17.625C0.5 17.75 0.6875 17.8438 0.875 17.8438C1.0625 17.8438 1.25 17.7812 1.375 17.625L9 10L16.625 17.625C16.75 17.75 16.9375 17.8438 17.125 17.8438C17.3125 17.8438 17.5 17.7812 17.625 17.625C17.9062 17.3438 17.9062 16.9062 17.625 16.625L10 9Z"
        fill="#111928"
      />
    </svg>
  );
};

export default CrossIconHeader;
